import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";
import {
  Time as TimeIcon,
  CheckCirclIcon,
} from "../../../../components/svgs";
import {
  Body,
  Children,
  DynamicButton,
  MainHolder,
  StyledText,
} from "../../../../components/common/basic";

import { logEvent } from "firebase/analytics";
import analytics from "../../../../context/analytics";
import { BackButton } from "../../../../components/common";
import { useHistory, useLocation } from "react-router-dom";
import { useTheme } from "../../../../hooks";
import { useSpinTheWheelHome } from "../hooks";
import RewardItemCard from "../../trivia/components/RewardItemCard";

const SpinTheWheelOrderDetails = () => {
  const history = useHistory();
  useEffect(() => {
    analytics().then(anl => logEvent(anl, "screen_view", {
      firebase_screen: "SpinTheWheelOrderDetails",
      firebase_screen_class: "SpinTheWheelOrderDetails",
    }));
  }, []);

  const { themeContext, theme } = useTheme();
  const themeColor = theme.colors[themeContext.activeTheme]["background"];
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const params = Object.fromEntries(searchParams);
  const { id } = params || {};

  const {
    background,
    userHistory,
    getItemFromStock,
    isOnGround,
  } = useSpinTheWheelHome();

  const selectedItem = userHistory?.find(item => id === item._id)
  const { name, imageUrl } = getItemFromStock(selectedItem?.itemCode) || {};

  const orders = [];
  const pickup = selectedItem?.officeLocation;

  return (
    <>
      <MainHolder>
        <BackButton onClick={() => history.goBack()} />
        <Children>
          <Header>
          </Header>
          <Body>
            <div style={{ boxSizing: 'border-box', padding: '0 15px' }}>
              {
                selectedItem &&
                <>
                  <RewardItemCard
                    color={background}
                    image={imageUrl}
                    name={name}
                    points={`Prize`}
                  />
                  <hr style={{ margin: '15px 0', borderTop: 'none', borderBottom: '1px solid #ddd' }} />

                  <StyledText size={18}>Order Status</StyledText>
                  <OrderStatusCard
                    location={pickup}
                    // stage={isOnGround ? "ready" : "in-progress"}
                    stage={"ready"}
                    enrouteDate={orders?.enrouteDate}
                    completedDate={orders?.completedDate}
                  />
                </>
              }
              <DynamicButton
                onClick={() => history.push(`/spin_the_wheel/redeem?id=${id}`)}
                label={"Claim your reward"}
                fullWidth
                color={themeColor}
              />

            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

// TODO: Move to loyalty components
const OrderStatusCard = ({ location, stage }) => {
  return (
    <>
      <div style={{ paddingLeft: '7px', boxSizing: 'border-box' }}>
        <OrderStatusStage isCompleted={stage === 'ready' || stage === 'in-progress'}>
          <StyledText size={12} style={{ margin: '0 0 5px 0', fontFamily: 'MTNRegular' }}>
            Reward Enroute to
            <span style={{ color: '#E31C79' }}> {location}</span>
          </StyledText>
          {
            // (stage === 'ready' || stage === 'in-progress') &&
            // <StyledText size={10} color="#828282" style={{ margin: 0, fontFamily: 'MTNRegular' }}>28/07/2022  09:54</StyledText>
          }
        </OrderStatusStage>

        <OrderStatusStage isCompleted={stage === 'ready'} isLast={true}>
          <StyledText size={12} style={{ margin: '0 0 5px 0', fontFamily: 'MTNRegular' }}>
            Reward is Ready for Pickup
          </StyledText>
          {
            // stage === 'ready' &&
            // <StyledText size={10} color="#828282" style={{ margin: 0, fontFamily: 'MTNRegular' }}>28/07/2022  09:54</StyledText>
          }
        </OrderStatusStage>
      </div>
      <div style={{
        display: 'flex',
        background: stage !== 'ready' ? '#FFCD00' : '#0FAF4B',
        color: stage !== 'ready' ? '#000' : '#fff',
        padding: '20px',
        borderRadius: '10px',
        justifyContent: 'space-around'
      }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {stage !== 'ready' ? <TimeIcon width={28} /> : <CheckCirclIcon color="#0FAF4B" fill="white" width={28} />}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', padding: '0 5px', width: '80%' }}>
          <div>
            <StyledText size={18} style={{ margin: '0 0 3px 0' }}>Order {stage !== 'ready' ? 'Pending' : 'Ready'}</StyledText>
            <StyledText size={10} style={{ margin: '0', fontFamily: 'MTNRegular' }}>
              {
                stage !== 'ready' ?
                  'You will be notified when your order is ready' : 'Locate an MTN Rep to pickup reward'
              }
            </StyledText>
          </div>
        </div>
      </div>
    </>
  )
}

const OrderStatusStage = ({ children, isCompleted, isLast }) => {
  return (
    <div style={{
      borderLeft: `2px solid ${isLast ? '#fff' : '#BDBDBD'}`,
      padding: '0 0 30px 20px',
      boxSizing: 'border-box',
      position: 'relative'
    }}
    >
      <div style={{
        background: '#BDBDBD',
        boxSizing: 'border-box',
        position: "absolute",
        height: '16px', width: '16px',
        borderRadius: '20px',
        top: 0,
        left: '-9px'
      }}>
        {isCompleted && <CheckCirclIcon width={16} fill={'#0FAF4B'} />}
      </div>
      {children}
    </div>
  )
}

const Header = styled.div`
  /* width: 360px; */
  overflow: hidden;
  padding: 20px 20px 10px 20px;
  background-color: ${({ background }) => background};
  position: relative;
`;

export default SpinTheWheelOrderDetails;
